import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { AboutSection } from '../components/AboutSection.jsx';
import BusinessBankingSection from '../components/BusinessBankingSection';
import CompetitiveSection from '../components/CompetitiveSection';
import DownloadAppSection from '../components/DownloadAppSection';
import EcosystemSection from '../components/EcosystemSection.jsx';
import FAQSection from '../components/FAQSection';
import FloatingSectionNav from '../components/FloatingSectionNav';
import HeroSection from '../components/HeroSection';
import PersonalBankingSection from '../components/PersonalBankingSection';
import ReferAndWin from '../components/ReferAndWin';
import ServicesSection from '../components/ServicesSection';
import SolutionSection from '../components/SolutionSection';
import TestimonialsSection from '../components/TestimonialsSection';
import { useSite } from '../context/SiteContext';
import customerRep from '../assets/images/constomer_rep_wb.jpg';

const SupportCTA = () => {
  const { ctaSections, loading } = useSite();
  const support = ctaSections?.support;

  const triggerChat = () => {
    if (window.wayaChat && window.wayaChat.toggle) {
      window.wayaChat.toggle();
    }
  };

  return (
    <section className="waya-support-cta" style={{ padding: '0 4% 80px' }}>
      <div className="waya-support-card" style={{
        backgroundImage: `url(${customerRep})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        borderRadius: '32px',
        textAlign: 'center',
        minHeight: '520px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-end',
        padding: '12px 20px',
        overflow: 'hidden',
        position: 'relative'
      }}>
        {/* Glassmorphic Card */}
        <div style={{
          background: 'rgba(255, 255, 255, 0.08)',
          backdropFilter: 'blur(24px)',
          WebkitBackdropFilter: 'blur(24px)',
          border: '1px solid rgba(255, 255, 255, 0.15)',
          borderRadius: '24px',
          padding: '28px 24px',
          maxWidth: '640px',
          width: '100%',
          margin: '0 auto',
          boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.4)',
          zIndex: 2
        }}>
          <h2 className="waya-section-heading" style={{ color: 'white', marginBottom: '8px', fontSize: '24px' }}>
            {loading ? (
              <Skeleton width="60%" />
            ) : (
              support?.title || "Have an issue? We're here to help."
            )}
          </h2>
          <p className="waya-section-subline" style={{ color: 'rgba(255,255,255,0.85)', maxWidth: '540px', margin: '0 auto 8px', fontSize: '15px' }}>
            {loading ? (
              <Skeleton count={2} />
            ) : (
              support?.subline ||
              'Our dedicated support team is available 24/7 to assist you with any questions or technical issues.'
            )}
          </p>
          <button
            onClick={triggerChat}
            className="waya-support-btn waya-support-btn-white"
            style={{
              background: '#fff',
              color: '#ff4400',
              fontWeight: '800',
              padding: '12px 28px',
              borderRadius: '10px',
              border: 'none',
              cursor: 'pointer',
              fontSize: '14px',
              transition: 'transform 0.2s ease'
            }}
            onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.05)'}
            onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
          >
            Talk to an Agent
          </button>
        </div>
      </div>
    </section>
  );
};

function Home() {
  return (
    <div id="homesection">
      <FloatingSectionNav />

      {/* 1. Hero: Capture Attention */}
      <div id="hero">
        <HeroSection />
      </div>
      {/* {
        THE ABOUT   SECTION
      } */}
      {/* <div id="about">
        <AboutSection />
      </div> */}

      {/* 2. Partners: Immediate Trust */}
      {/* <div id="partners">
        <PartnersSection />
      </div> */}

      {/* 3. Services: Quick Overview */}
      <div id="services">
        <ServicesSection />
      </div>

      {/* 4. Personal Banking: Core User Journey */}
      <div id="personal">
        <PersonalBankingSection />
      </div>

      {/* 5. Business Banking: Core User Journey */}
      <div id="business">
        <BusinessBankingSection />
      </div>

      {/* 6. Competitive: Why WayaBank? */}
      <div id="competitive">
        <CompetitiveSection />
      </div>

      {/* 7. Solution: How it Works */}
      <div id="solution">
        <SolutionSection />
      </div>

      {/* 8. Testimonials: Social Proof Reinforcement */}
      <div id="testimonials">
        <TestimonialsSection />
      </div>

      {/* 9. Refer & Win: Rewards & Growth */}
      <div id="refer">
        <ReferAndWin />
      </div>

      {/* 10. Ecosystem: WayaLinks Vision */}
      <div id="ecosystem">
        <EcosystemSection />
      </div>

      {/* 11. FAQ: Answering Questions */}
      <div id="faq">
        <FAQSection />
      </div>

      {/* 12. Blog: Latest News & Insights */}
      {/* <div id="blog">
        <BlogSection filter="featured" />
      </div> */}

      {/* 13. Support: Direct Assistance */}
      <SupportCTA />

      {/* 14. Download: Final Conversion Push */}
      <div id="download">
        <DownloadAppSection />
      </div>
    </div>
  );
}

export default Home;
